import React from "react";
import "react-data-table-component-extensions/dist/index.css";
import { ColorCodePerUserTable } from "../allTables/allTable";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import ColorCodeService from "../../services/coloeCode.service";

export function SingleColorCode() {
  const [data, setData] = useState("");
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const getSingleUser = async () => {
    setIsLoading(true);
    try {
      const response = await ColorCodeService.GetSingleColorCode(id);
      setData(response.data.data.colorCodeDetail);
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getSingleUser();
  }, []);

  return (
    <>
      <div className="page-header2"></div>
      <ColorCodePerUserTable data={data}isLoading={isLoading} />
    </>
  );
}
